const sendPostMessageToParent = ({ type, data }) => {
  const postMessage = { type, data }

  window.parent.postMessage(postMessage, '*')

  console.log('[FE panel legacy] postMessage sended to parent', postMessage)
}

export default sendPostMessageToParent
